'use strict';

import React from 'react';
import MediaArticleComponent from './MediaArticleComponent';
import ProductComponent from './ProductComponent';
import API from 'sources/API';

require('styles/MediaArticleList.scss');

class MediaArticleListComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
			imgs:[]
    };
    this.showPic = this.showPic.bind(this);
  }
	componentDidMount() {
    if(API.isWechat){
      fetch(API.getWechatConfig).then(res=>res.json()).then(json=>{
        if(json.appId) {
            window.wx.config(json);
        }
      })
    }
  }
	showPic(url){
		if(API.isWechat){
      wx.previewImage({
        current: url, // 当前显示图片的http链接
        urls: this.state.imgs?this.state.imgs:[]// 需要预览的图片http链接列表
      });
    }
	}
	componentWillReceiveProps(nextProps) {
		let {mediaList} = nextProps;
		let imgs = new Array();
		mediaList.forEach(function(media){
      if(media && media._id){
        let temp = media.images.origin?media.images.origin:[];
        imgs = imgs.concat(temp);
      }
		});
		this.setState({imgs:imgs});
  }
  render(){
    let {mediaList,product,recommendArticles,view_article} = this.props;
    let productReveal;
    if(product){
      productReveal = <ProductComponent product={product} />;
    }
    let medias = [];
    for (let index = 0; index < mediaList.length; index++) {
      let media = mediaList[index];
      if(media && media._id){
        medias.push(<MediaArticleComponent showPic={this.showPic} media={media} index={index} key={media._id}/>);
        // if(index%2==0){
        // if(index==0){
          // medias.push(productReveal);
        // }
      }
    }

    let albumsRecommendReveal;
    if(recommendArticles && recommendArticles.length){
      albumsRecommendReveal = (
        <div className="recommend">
          <div className="bg-white recommend">
            <p className="fz-12 text-highlighted">文章推荐:</p>
            {recommendArticles.map(album => (
            <a href={`/article/${album._id}`} className="item" key={album._id}>
              <div className="cover">
                <img src={album.medias[0].images.big[0]} />
              </div>
              <div className="title">
                {album.medias[0].desc}
              </div>
            </a>
            ))}
            <div className="clear"></div>
          </div>
        </div>
      );
    }

		return (
			<div className="media-article-list-component">
        {medias}
        {productReveal}
        {albumsRecommendReveal}
      	<div className='view-count'>
					阅读量: {(view_article)||0}
				</div>
 				<div className="bottom"></div>
				<div className="ads">
					<img src="https://img.xiaodiqiu.cn/ads.jpeg" />
				</div>
			</div>
		);
  }
}

MediaArticleListComponent.displayName = 'MediaArticleListComponent';

export default MediaArticleListComponent;



// WEBPACK FOOTER //
// ./src/components/MediaArticleListComponent.js